<template>
    <v-row>
        <v-col cols="10" offset="1">
            <Imprint v-if="mode === 'imprint'"></Imprint>
            <Privacy v-else></Privacy>
        </v-col>
    </v-row>
</template>

<script>
import Imprint from "./Imprint.vue";
import Privacy from "./Privacy.vue";

export default {
    props: {
        mode: String
    },
    components: {
        Imprint,
        Privacy
    }
}
</script>